import React from 'react'
import withNinetailedExperience from '@toasttab/shared/src/utils/Ninetailed/withNinetailedExperience'
import ExitIntent from '@toasttab/shared/src/components/molecules/ExitIntentModal/ExitIntentModal'
import { ContentfulExitIntentJsonDataObject } from '@toasttab/shared/src/interfaces/ContentfulExitIntentJsonDataObject'
import { ContentfulShowcaseForm } from '@toasttab/shared/src/interfaces/ContentfulShowcaseForm'

interface NTExitIntentProps {
  exitIntentShowcaseForm: ContentfulShowcaseForm
  exitIntentJsonDataObjectBaseline: ContentfulExitIntentJsonDataObject
}

export const NTExitIntent: React.FC<NTExitIntentProps> = React.memo(
  ({ exitIntentShowcaseForm, exitIntentJsonDataObjectBaseline }) => {
    return withNinetailedExperience(
      (props: ContentfulExitIntentJsonDataObject) =>
        props.contentObject.isVariant ? (
          <ExitIntent showcaseForm={exitIntentShowcaseForm} />
        ) : null,
      exitIntentJsonDataObjectBaseline,
      false
    )
  }
)
